<template>
  <div class="account main p20">
    <div class="mt20">
      <span class="title1">个人资料</span>
    </div>
    <div class="mt50">
      <Form :model="formItem" :label-width="120">
        <FormItem label="邮箱">
          <span>{{formItem.email}}</span>
        </FormItem>
        <FormItem label="姓名">
          <Input v-if="is_edit" class="w300" v-model="formItem.contact_name" placeholder="请输入姓名"></Input>
          <span v-else>{{formItem.contact_name}}</span>
        </FormItem>
        <FormItem label="客户姓名">
          <Input v-if="is_edit" class="w300" v-model="formItem.name" placeholder="请输入姓名"></Input>
          <span v-else>{{formItem.name}}</span>
        </FormItem>
        <FormItem label="联系电话">
          <Input v-if="is_edit" class="w300" v-model="formItem.contact_phone" placeholder="请输入联系电话"></Input>
          <span v-else>{{formItem.contact_phone}}</span>
        </FormItem>
      </Form>

      <div class="mt30">
        <div v-if="is_edit">
          <button class="ivu-btn ivu-btn-primary ml150" @click="save">更 新</button>
          <button class="ivu-btn ivu-btn-white ml10" @click="is_edit=false;getInfo()">取消</button>
        </div>
        <div v-else>
          <button class="ivu-btn ivu-btn-primary ml150" @click="is_edit=true">编辑资料</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        formItem: {},
        is_edit: false,
        gender: '未知'
      }
    },
    methods: {
      getInfo() {
        this.$axios.get('/client/info').then(res => {
          if (res.success) {
            this.formItem = res.data
          }
        })
      },
      save() {
        let data = {...this.formItem}
        if (!data.contact_name) {
          this.$Message.warning("请输入客户姓名");
          return
        }
        if (!data.name) {
          this.$Message.warning("请输入姓名");
          return
        }
        if (!data.contact_phone) {
          this.$Message.warning("请输入客户电话");
          return
        }
        this.$axios.post("/client/info", this.$qs.stringify(data)).then(res => {
          if (res.success) {
            this.$Message.success("更新成功");
            this.is_edit = false;
            this.getInfo();
          }else{
            this.$Message.info(res.msg)
          }
        });
      },
    },
    created() {
      this.getInfo()
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/client_mgr/userinfo.vue